module.exports = __webpack_public_path__ + "img/ic-JCB-white.60edd5d6.svg";